import CadastroContainer from "../../../components/CadastroContainer/CadastroContainer";
import FormLicense from "./FormLicense";

export function NewLicense({ ...props }) {

   return (
      <CadastroContainer>
         <FormLicense type="cadastro" />
      </CadastroContainer>
   );
}